import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
export function BeforeAfter() {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const handleMove = (clientX: number) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const percentage = x / rect.width * 100;
    setSliderPosition(Math.max(0, Math.min(100, percentage)));
  };
  const handleMouseMove = (e: React.MouseEvent) => {
    if (isDragging) {
      handleMove(e.clientX);
    }
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    if (isDragging && e.touches[0]) {
      handleMove(e.touches[0].clientX);
    }
  };
  return <section className="py-32 px-6 bg-matte-black" data-id="element-30">
      <div className="max-w-7xl mx-auto" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-32">
          <h2 className="font-playfair text-5xl md:text-6xl font-bold text-off-white mb-4" data-id="element-33">
            Transformation
          </h2>
          <p className="font-inter text-lg text-off-white/60" data-id="element-34">
            Drag to see the difference
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto" data-id="element-35">
          <div ref={containerRef} className="relative aspect-[4/3] rounded-2xl overflow-hidden select-none" onMouseDown={() => setIsDragging(true)} onMouseUp={() => setIsDragging(false)} onMouseLeave={() => setIsDragging(false)} onMouseMove={handleMouseMove} onTouchStart={() => setIsDragging(true)} onTouchEnd={() => setIsDragging(false)} onTouchMove={handleTouchMove} data-id="element-36">
            {/* Before image (left side) */}
            <div className="absolute inset-0 bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900" style={{
            clipPath: `inset(0 ${100 - sliderPosition}% 0 0)`
          }} data-id="element-37">
              <div className="absolute top-8 left-8 bg-matte-black/80 backdrop-blur-sm px-4 py-2 rounded-full" data-id="element-38">
                <span className="font-inter text-sm font-semibold text-off-white" data-id="element-39">
                  BEFORE
                </span>
              </div>
            </div>

            {/* After image (right side) */}
            <div className="absolute inset-0 bg-gradient-to-br from-deep-green via-soft-gold/20 to-matte-black" data-id="element-40">
              <div className="absolute top-8 right-8 bg-matte-black/80 backdrop-blur-sm px-4 py-2 rounded-full" data-id="element-41">
                <span className="font-inter text-sm font-semibold text-soft-gold" data-id="element-42">
                  AFTER
                </span>
              </div>
            </div>

            {/* Slider */}
            <div className="absolute top-0 bottom-0 w-1 bg-soft-gold cursor-ew-resize" style={{
            left: `${sliderPosition}%`
          }} data-id="element-43">
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-soft-gold rounded-full flex items-center justify-center shadow-[0_0_20px_rgba(212,175,55,0.5)]" data-id="element-44">
                <div className="flex gap-1" data-id="element-45">
                  <div className="w-0.5 h-4 bg-matte-black rounded-full" data-id="element-46" />
                  <div className="w-0.5 h-4 bg-matte-black rounded-full" data-id="element-47" />
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}